import { Component } from '@angular/core';
import { NavController,NavParams } from 'ionic-angular';
import { AppState } from '../../../app/app.global';

@Component({
  selector: 'page-remind',
  templateUrl: 'remind.html'
})
export class RemindPage {

	trip:any;
	
	reminds = [
		{id:'0',name:'永不'},
		{id:'5',name:'5分钟'},
		{id:'15',name:'15分钟'},
		{id:'30',name:'30分钟'},
		{id:'60',name:'1小时'},
		{id:'120',name:'2小时'},
		{id:'1440',name:'1天前'},
		{id:'2880',name:'2天前'},
		{id:'10080',name:'1周前'}
	];

  constructor(public navCtrl: NavController,public params: NavParams,public global: AppState) {
			this.trip =  params.data.trip;
  }

  setCalendar(item:any){
	  	if(item){
		  	this.trip.remindValue = item.id;
		  	this.trip.remind = item.name;
	  	}
      this.navCtrl.pop();
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/trip/remind/remind.ts